import Axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import store from '../../store';

export class HttpApi {
  httpClient = Axios.create({
    baseURL: this.baseUrl,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    withCredentials: true
  });

  get baseUrl() {
    return 'https://api.goodyiyao.cn/web/';
    // return process.env.NODE_ENV === 'production'? AppConfig.productionURL: AppConfig.developmentURL;
  }

  post(url, data = {}, headers) {
    return new Promise((resolve, reject) => {
      data.token = localStorage.getItem('token');
      this.httpClient.post(url, qs.stringify(data), { headers}).then((response) => {
        const result = this.parse(response);
        if (response.status === 200) {
          resolve(result.data);
          if(result.msg) { Message.success({message: result.msg}); }
        } else {
          this.unifyError(reject, url)(response.data);
        }
      }).catch(this.unifyError(reject, url));
    });
  }

  get(url, data = {}) {
    return new Promise((resolve, reject) => {
      data.token = data.token || localStorage.getItem('token');
      const queryParams = this.objectToUrlString(data || {});
      this.httpClient.get(`${url}${queryParams? '?' + queryParams: ''}`).then((response) => {
        if (response.status === 200) {
          resolve(this.parse(response.data));
        } else {
          this.unifyError(reject, url)(response.data);
        }
      }).catch(this.unifyError(reject, url));
    });
  }

  // 以下方法属于工具函数

  unifyError(reject, url) {
    return (error) => {
      Message.error(error.msg)
      if (error.errcode === 10001 && url !== '/wechat/isBind') {
        localStorage.clear();
        store.commit('calculationNumber', 0)
        store.commit('SET_NAME','')
        location.reload();
        Message.warning('请登录');
      }
      reject(error);
      console.log(error, url);
    };
  }

  parse(data) {
    return typeof data === 'string'? JSON.parse(data): data;
  }

  objectToUrlString = (obj, encode = false) => {
    const result = [];
    for (const item in obj) {
      result.push(`${item}=${encode? encodeURIComponent(obj[item]): obj[item]}`);
    }
    return result.join('&');
  }

}
